import { useState, useEffect } from 'react';
import { settingsService } from '../services/api';
import './Settings.css';

export default function Settings() {
  const [settings, setSettings] = useState({});
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [msg, setMsg] = useState('');

  async function load() {
    setLoading(true);
    const res = await settingsService.get();
    if (res.success) setSettings(res.settings || {});
    setLoading(false);
  }
  useEffect(() => { load(); }, []);

  function set(key, value) { setSettings((prev) => ({ ...prev, [key]: value })); }
  const bool = (key) => settings[key] === 'true' || settings[key] === true;

  async function save() {
    setSaving(true); setMsg('');
    const res = await settingsService.update(settings);
    setSaving(false);
    setMsg(res.success ? 'Saved' : (res.error || 'Failed to save'));
    setTimeout(() => setMsg(''), 2500);
  }

  if (loading) return <div className="empty-state"><div className="loading-spinner"></div></div>;

  return (
    <div className="settings-page">
      <div className="page-header">
        <h1 className="page-title">Settings</h1>
        <div className="flex items-center gap-sm">
          {msg && <span className="text-success">{msg}</span>}
          <button className="btn btn-primary" onClick={save} disabled={saving}>{saving ? 'Saving…' : 'Save'}</button>
        </div>
      </div>

      <section className="card settings-section">
        <h2 className="card-title mb-md">Business details</h2>
        <div className="form-group">
          <label htmlFor="business_name">Business name</label>
          <input id="business_name" value={settings.business_name || ''} onChange={(e) => set('business_name', e.target.value)} />
        </div>
        <div className="form-group">
          <label htmlFor="business_email">Reply-to / from email</label>
          <input id="business_email" type="email" value={settings.business_email || ''} onChange={(e) => set('business_email', e.target.value)} />
        </div>
        <div className="form-group">
          <label htmlFor="timezone">Timezone</label>
          <input id="timezone" value={settings.timezone || ''} readOnly />
        </div>
      </section>

      <section className="card settings-section">
        <h2 className="card-title mb-md">Booking rules (defaults)</h2>
        <div className="form-row">
          <div className="form-group">
            <label htmlFor="slot_granularity_minutes">Slot interval (min)</label>
            <input id="slot_granularity_minutes" type="number" min="5" step="5" value={settings.slot_granularity_minutes || ''} onChange={(e) => set('slot_granularity_minutes', e.target.value)} />
          </div>
          <div className="form-group">
            <label htmlFor="default_min_notice_minutes">Min notice (min)</label>
            <input id="default_min_notice_minutes" type="number" min="0" step="30" value={settings.default_min_notice_minutes || ''} onChange={(e) => set('default_min_notice_minutes', e.target.value)} />
          </div>
          <div className="form-group">
            <label htmlFor="default_max_advance_days">Book up to (days ahead)</label>
            <input id="default_max_advance_days" type="number" min="1" value={settings.default_max_advance_days || ''} onChange={(e) => set('default_max_advance_days', e.target.value)} />
          </div>
        </div>
        <p className="text-muted settings-hint">These are defaults — each meeting type can override its own notice, buffers and horizon.</p>
      </section>

      <section className="card settings-section">
        <h2 className="card-title mb-md">Notifications &amp; public booking</h2>
        <div className="form-group">
          <label htmlFor="reminder_lead_minutes">Reminder lead time (min before)</label>
          <input id="reminder_lead_minutes" type="number" min="0" step="30" value={settings.reminder_lead_minutes || ''} onChange={(e) => set('reminder_lead_minutes', e.target.value)} />
        </div>
        <label className="checkbox-label settings-toggle">
          <input type="checkbox" checked={bool('public_booking_enabled')} onChange={(e) => set('public_booking_enabled', String(e.target.checked))} />
          Public booking page is live
        </label>
        <label className="checkbox-label settings-toggle">
          <input type="checkbox" checked={bool('auto_confirm_bookings')} onChange={(e) => set('auto_confirm_bookings', String(e.target.checked))} />
          Auto-confirm client bookings (otherwise they land as “pending”)
        </label>
      </section>
    </div>
  );
}
